import { Pagination, PaginationItem, PaginationProps, PaginationRenderItemParams } from '@mui/material';

const paginationButtonTypes: PaginationRenderItemParams['type'][] = [
  'page',
  'first',
  'last',
  'previous',
  'next',
];

export default function AccessiblePagination({ renderItem, ...props }: PaginationProps) {
  return (
    <Pagination
      {...props}
      aria-label="Pagination"
      renderItem={(item) => {
        if (renderItem) {
          return renderItem(item);
        }

        return (
          <PaginationItem
            {...item}
            role={paginationButtonTypes.includes(item.type) ? 'link' : undefined}
          />
        );
      }}
    />
  );
}
